import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import BaseTemperatureChannel from '@avtechsoftware/ra-javascript-utilities/src/classes/channels/BaseTemperatureChannel/BaseTemperatureChannel';

function getChannelValueWithUnitsFromChannelKeyObjectString(
  customScales = { temperatureScale: 'C', airSpeedScale: 'm/s' }, channelKey, value, customUnits,
) {
  const channel = ChannelService.getChannelGroupChannel(
    channelKey.channelGroupType,
    channelKey.channelIndex,
    channelKey.channelType,
  );
  const scale = channel instanceof BaseTemperatureChannel
    ? customScales.temperatureScale
    : customScales.airSpeedScale;
  return `${channel.getDisplayValue(value, { scale, airSpeedScale: customScales.airSpeedScale })} ${channel.getUnits({ scale, airSpeedScale: customScales.airSpeedScale, customUnits })}`;
}

export default getChannelValueWithUnitsFromChannelKeyObjectString;
